function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "printer"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m20 6h-2v-3c0-.553-.447-1-1-1h-10c-.553 0-1 .447-1 1v3h-2c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h2v3c0 .553.447 1 1 1h10c.553 0 1-.447 1-1v-3h2c1.103 0 2-.897 2-2v-8c0-1.103-.897-2-2-2zm-12-2h8v2h-8zm8 16h-8v-4h8zm4-4h-2v-1c0-.553-.447-1-1-1h-10c-.553 0-1 .447-1 1v1h-2v-8h16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m6 9c-.26 0-.52.11-.71.29-.181.19-.29.45-.29.71s.109.52.29.71c.38.37 1.04.37 1.42 0 .18-.19.29-.45.29-.71s-.11-.52-.29-.71c-.19-.18-.45-.29-.71-.29z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14 17h-4c-.553 0-1 .447-1 1s.447 1 1 1h4c.553 0 1-.447 1-1s-.447-1-1-1z"
})));

var Svg094Printer = function Svg094Printer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg094Printer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/094-printer.8e565db7.svg";
export { ForwardRef as ReactComponent };